export default __webpack_public_path__ + "static/media/cplogo.90cbd43a.png";